// Import Vue
import Vue from 'vue'
import Vuex from 'vuex'

// Init Vuex.
Vue.use(Vuex)
const dStoreText = 'datos-estilo'
const dStoreAuth = 'datos-autenticacion'
const dStorePortal = 'datos-portal'
const store = new Vuex.Store({
  state: {
    datosEstilo: JSON.parse(localStorage.getItem(dStoreText)) || {
      path: 'base'
    },
    orderStatus: [],
    styleRootPath: '/static/style',
    urlInfo: null,
    datosAutenticacion: JSON.parse(localStorage.getItem(dStoreAuth)) || null,
    datosPortal: JSON.parse(localStorage.getItem(dStorePortal)) || null,
    pais: '011',
    modulo: localStorage.getItem('modulo') || process.env.DEFAULT_MODULE,
    imagenDefecto: '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',
    drawer: false,
    arbol: [],
    breadcrumbs: [],
    filters: [],
    carrito: JSON.parse(localStorage.getItem('carrito')) || [],
    paginacionFamilas: 9,
    paginacionProductos: 12,
    presupuesto: null
  },
  mutations: {
    setOrderStatus (state, data) {
      state.orderStatus = []
      for (let i = 0; i < data.length; i++) {
        state.orderStatus.push(data[i])
      }
    },
    removeOrderStatus (state) {
      state.orderStatus = null;
      
    },
    setEstilo (state, datosEstilo) {
      state.datosEstilo = datosEstilo
      localStorage.setItem(dStoreText, JSON.stringify(state.datosEstilo))
    },
    setUrlInfo (state, urlInfo) {
      state.urlInfo = urlInfo
      localStorage.setItem('urlInfo', JSON.stringify(state.urlInfo))
    },
    removeEstilo (state) {
      state.datosEstilo = null
      localStorage.removeItem(dStoreText)
    },
    setAutenticacion (state, datosAutenticacion) {
      // Si no tiene la organización añade la por defecto
      if (datosAutenticacion.organizacion === undefined) {
        datosAutenticacion.organizacion = state.organizacion
      }
      state.datosAutenticacion = datosAutenticacion
      localStorage.setItem(dStoreAuth, JSON.stringify(state.datosAutenticacion))
    },
    setAutenticacionPortal (state, datosAutenticacion) {
      state.datosPortal = datosAutenticacion;
      localStorage.setItem(dStorePortal, JSON.stringify(state.datosPortal))
    },
    removeAutenticacion (state) {
      state.datosAutenticacion = null
      state.urlInfo = null
      localStorage.removeItem(dStoreAuth)
      localStorage.removeItem(dStorePortal)
      localStorage.removeItem('modulo')
      localStorage.removeItem('urlInfo')
      localStorage.removeItem('refreshToken')
    },
    setRefreshToken (state, refreshToken) {
      localStorage.setItem('refreshToken', refreshToken)
    },
    setModulo (state, modulo) {
      state.modulo = modulo
      localStorage.setItem('modulo', state.modulo)
    },
    removeModulo (state) {
      state.modulo = null
      localStorage.setItem('modulo', process.env.DEFAULT_MODULE)
    },
    setDrawer (state, drawer) {
      state.drawer = drawer
    },
    removeDrawer (state) {
      state.drawer = null
    },
    setArbol (state, arbol) {
      state.arbol = arbol
    },
    removeArbol (state) {
      state.arbol = null
    },
    setBreadcrumbs (state, breadcrumbs) {
      state.breadcrumbs = breadcrumbs
    },
    removeBreadcrumbs (state) {
      state.breadcrumbs = null
    },
    setFilters (state, filters) {
      state.filters = filters
    },
    removeFilters (state) {
      state.filters = null
    },
    setCarrito (state, carrito) {
      state.carrito = carrito
      localStorage.setItem('carrito', JSON.stringify(state.carrito))
    },
    removeCarrito (state) {
      state.carrito = []
      localStorage.setItem('carrito', JSON.stringify(state.carrito))
    },
    addProducto (state, producto) {
      state.carrito.push(producto)
      localStorage.setItem('carrito', JSON.stringify(state.carrito))
    },
    removeProducto (state, index) {
      state.carrito.splice(index, 1)
      localStorage.setItem('carrito', JSON.stringify(state.carrito))
    },
    setPresupuesto (state, presupuesto) {
      state.presupuesto = presupuesto
    },
    removePresupuesto (state) {
      state.presupuesto = null
    }
  },
  actions: {

  },
  getters: {
    getState: state => {
      return state
    },
    getUrlInfo: state => {
      if (state.urlInfo === null && localStorage.getItem('urlInfo') !== null) {
        state.urlInfo = JSON.parse(localStorage.getItem('urlInfo'))
      }
      return state.urlInfo
    },
    getStyleRootPath: state => state.styleRootPath,
    
    getStylePath: state => {
      const urlCabecera = localStorage.getItem('urlCabecera')
      const styleOrgPath = (urlCabecera !== undefined) ? urlCabecera : 'base'
      return '../../static/style/' + styleOrgPath 
    },
    getOrderStatus: state => {
      return state.orderStatus
    },
    getAutenticacion: state => state.datosAutenticacion,
    getAuthPortal: state => state.datosPortal,
    getModulo: state => state.modulo,
    getPrueba: state => state.prueba,
    getPais: state => state.pais,
    getImagenDefecto: state => state.imagenDefecto,
    getDrawer: state => state.drawer,
    getArbol: state => state.arbol,
    getBreadcrumbs: state => state.breadcrumbs,
    getFilters: state => state.filters,
    getCarrito: state => state.carrito,
    getPaginacionFamilias: state => state.paginacionFamilias,
    getPaginacionProductos: state => state.paginacionProductos,
    getPresupuesto: state => state.presupuesto
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store.js